<template>
  <b-container>
    <div class="edit-job-page page">
      <div class="page__header">
        <h2>Edit Tool</h2>
      </div>
      <div class="page__card mt-0">
        <div class="page__card__content page__card__content--lg">
          <job-form v-if="job" />
        </div>
      </div>
    </div>
  </b-container>
</template>
<script>
/**
 * ==================================================================================
 * Edit Job/Tool page
 * ==================================================================================
 **/

import { mapState, mapMutations, mapActions } from 'vuex'
import JobForm from '@/components/forms/JobForm'

export default {
  metaInfo: function() {
    return {
      title: 'Edit Tool'
    }
  },
  components: {
    JobForm
  },
  watch: {
    user(value) {
      this.checkPermission()
    },

    job(value) {
      this.checkPermission()
    }
  },
  computed: {
    ...mapState({
      user: state => state.auth.user,
      job: state => state.job.jobDetails
    })
  },
  data: function() {
    return {
      loading: false
    }
  },
  methods: {
    ...mapActions({
      getJobDetails: 'job/getJobDetails'
    }),
    ...mapMutations({
      clearJobDetails: 'job/clearJobDetails'
    }),
    async fetchJob() {
      if (this.loading) return
      this.loading = true
      await this.getJobDetails({
        id: this.$route.params.id
      })
        .then(() => {
          this.loading = false
        })
        .catch(() => {
          this.loading = false
          this.$router.replace({ name: 'page-not-found' })
        })
    },

    checkPermission() {
      if (this.job && this.user) {
        if (this.job.owner.id !== this.user.id) {
          this.$router.replace({
            name: 'job.my-jobs-page'
          })
        }
      }
    }
  },
  created() {
    this.clearJobDetails()
    this.fetchJob()
  }
}
</script>
<style scoped lang="scss">
.edit-job-page {
}
</style>
